import { useEffect } from "react";
import { Form } from "antd";
import { useAtom } from "jotai";
import { frmPreguntasPuntualidadAtom, puntajeTotalPuntualidadAtom } from "../../BandejaEvaluacionStorage";

const usePreguntasPuntualidad = () => {
	const [puntajeTotal, setPuntajeTotal] = useAtom(puntajeTotalPuntualidadAtom);
	const [frmPreguntas, setFrmPreguntas] = useAtom(frmPreguntasPuntualidadAtom);
	const [form] = Form.useForm();

	useEffect(() => {
		if (!frmPreguntas) {
			setFrmPreguntas(form);
		}
	}, []);

	return { frmPreguntas, puntajeTotal, setPuntajeTotal };
};

export default usePreguntasPuntualidad;
